import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import { useTranslation } from 'react-i18next';

import { SidebarTypes } from 'layout/MainLayout/components/Sidebar/types';
import { HomeRoutePath } from 'shared/constants/router';
import { useIsParentHelper } from 'shared/hooks/user';

import type { NavigationItem } from 'layout/MainLayout/components/Sidebar/types';

export const useParentExtraNavigationItems = ():
  | NavigationItem[]
  | undefined => {
  const { t } = useTranslation();
  const isParentHelper = useIsParentHelper();

  if (isParentHelper) {
    return [
      {
        label: t('sidebar.parentHelper'),
        icon: <SupportAgentOutlinedIcon />,
        to: HomeRoutePath.ParentHelper,
        sidebarType: SidebarTypes.DEFAULT,
      },
    ];
  }

  return undefined;
};
